

//  团队会员页面的常见问题配置项
export const getteamQAConfigList  = (t: any) => {
	let teamConfigList = [
      {
        questionTitle: t('edit_question_title_1'),
        contents:[
          t('edit_zh_question_content_1'),
        ]
      },
      {
        questionTitle: t('edit_question_title_2'),
        contents:[
          t('edit_zh_question_content_2'),
        ]
      },
      {
        questionTitle: t('edit_question_title_3'),
        contents:[
          t('edit_zh_question_content_3'),
        ]
      },
      {
        questionTitle: t('edit_question_title_4'),
        contents:[
          t('edit_zh_question_content_4'),
        ]
      },
      {
        questionTitle: t('edit_question_title_5'),
        contents:[
          t('edit_zh_question_content_5'),
        ]
      },
      {
        questionTitle: t('edit_question_title_6'),
        contents:[
          t('edit_zh_question_content_6'),
        ]
      },
      {
        questionTitle: t('edit_question_title_7'),
        contents:[
          t('edit_zh_question_content_7'),
        ]
      }
    ]
		return teamConfigList
}
// 上传首页，免费翻译 常见问题
export const getFreeTranslateQAConfigList  = (t: any) => {
	let teamConfigList = [
      {
        questionTitle: t('translate_free_question_title9'),
        contents:[
          t('translate_free_question_content9-1'),
          t('translate_free_question_content9-2'),
          t('translate_free_question_content9-3'),
          t('translate_free_question_content9-4')
        ]
      },
      {
        questionTitle: t('translate_free_question_title1'),
        contents:[
          t('translate_free_question_content1-1')
        ]
      },
      {
        questionTitle: t('translate_free_question_title2'),
        contents:[
          t('translate_free_question_content2-1')
        ]
      },
      {
        questionTitle: t('translate_free_question_title3'),
        contents:[
          t('translate_free_question_content3-1')
        ]
      },
      {
        questionTitle: t('translate_free_question_title4'),
        contents:[
          t('translate_free_question_content4-1')
        ]
      },
      {
        questionTitle: t('translate_free_question_title5'),
        contents:[
          t('translate_free_question_content5-1')
        ]
      },
      {
        questionTitle: t('translate_free_question_title6'),
        contents:[
          t('translate_free_question_content6-1'),
        ]
      },
      {
        questionTitle: t('translate_free_question_title7'),
        contents:[
          t('translate_free_question_content7-1'),
          t('translate_free_question_content7-2'),
          t('translate_free_question_content7-3'),
        ]
      },
      {
        questionTitle: t('translate_free_question_title8'),
        contents:[
          t('translate_free_question_content8-1')
        ]
      },
    ]
		return teamConfigList
}
// 专家级翻译 常见问题
export const getAdvancedTranslateQAConfigList  = (t: any) => {
	let teamConfigList = [
      {
        questionTitle: t('translate_member_question_title1'),
        contents:[
          t('translate_member_question_content1-1'),
        ]
      },
      {
        questionTitle: t('translate_member_question_title2'),
        contents:[
          t('translate_member_question_content2-1'),
        ]
      },
      {
        questionTitle: t('translate_member_question_title3'),
        contents:[
          t('translate_member_question_content3-1'),
        ]
      },
      {
        questionTitle: t('translate_member_question_title4'),
        contents:[
          t('translate_member_question_content4-1'),
        ]
      },
      {
        questionTitle: t('translate_member_question_title5'),
        contents:[
          t('translate_member_question_content5-1'),
        ]
      },
      {
        questionTitle: t('translate_member_question_title6'),
        contents:[
          t('translate_member_question_content6-1'),
        ]
      },
      {
        questionTitle: t('translate_member_question_title7'),
        contents:[
          t('translate_member_question_content7-1'),
        ]
      },
      {
        questionTitle: t('translate_member_question_title8'),
        contents:[
          t('translate_member_question_content8-1'),
        ]
      },
      {
        questionTitle: t('translate_member_question_title9'),
        contents:[
          t('translate_member_question_content9-1'),
        ]
      },
      {
        questionTitle: t('translate_member_question_title10'),
        contents:[
          t('translate_member_question_content10-1'),
        ]
      }
    ]
		return teamConfigList
}
// ar 论文常见问题
export const getARTranslateQAConfigList  = (t: any) => {
	let teamConfigList = [
      {
        questionTitle: t('translate_ar_question_title1'),
        contents:[
          t('translate_ar_question_content1-1'),
        ]
      },
      {
        questionTitle: t('translate_ar_question_title2'),
        contents:[
          t('translate_ar_question_content2-1'),
        ]
      },
      {
        questionTitle: t('translate_ar_question_title3'),
        contents:[
          t('translate_ar_question_content3-1'),
        ]
      }
    ]
		return teamConfigList
}
// ai 文本翻译 常见问题
export const getAITranslateQAConfigList  = (t: any) => {
	let teamConfigList = [
      {
        questionTitle: t('translate_aiText_question_title1'),
        contents:[
          t('translate_aiText_question_content1-1'),
        ]
      },
      {
        questionTitle: t('translate_aiText_question_title2'),
        contents:[
          t('translate_aiText_question_content2-1'),
        ]
      },
      {
        questionTitle: t('translate_aiText_question_title3'),
        contents:[
          t('translate_aiText_question_content3-1'),
        ]
      },{
        questionTitle: t('translate_aiText_question_title4'),
        contents:[
          t('translate_aiText_question_content4-1'),
        ]
      }
    ]
		return teamConfigList
}

export const getHomeQAConfigList  = (t: any) => {
	let homeConfigList = [
      {
        questionTitle: t('home-pro-question-title1'),
        contents:[
          t('home-pro-question-content1-1'),
        ]
      },
      {
        questionTitle: t('home-pro-question-title2'),
        contents:[
          t('home-pro-question-content2-1'),
          t('home-pro-question-content2-2'),
        ]
      },
      {
        questionTitle: t('home-pro-question-title3'),
        contents:[
          t('home-pro-question-content3-1'),
        ]
      },{
        questionTitle: t('home-pro-question-title4'),
        contents:[
          t('home-pro-question-content4-1'),
        ]
      },{
        questionTitle: t('home-pro-question-title5'),
        contents:[
          t('home-pro-question-content5-1'),
          t('home-pro-question-content5-2'),
        ]
      },{
        questionTitle: t('home-pro-question-title6'),
        contents:[
          t('home-pro-question-content6-1'),
        ]
      },{
        questionTitle: t('home-pro-question-title7'),
        contents:[
          t('home-pro-question-content7-1'),
        ]
      },{
        questionTitle: t('home-pro-question-title8'),
        contents:[
          t('home-pro-question-content8-1'),
        ]
      }
    ]
		return homeConfigList
}